import { render, staticRenderFns } from "./comRate.vue?vue&type=template&id=4eda3b8c"
import script from "./comRate.vue?vue&type=script&lang=js"
export * from "./comRate.vue?vue&type=script&lang=js"
import style0 from "./comRate.vue?vue&type=style&index=0&id=4eda3b8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports